import { render, staticRenderFns } from "./Monolith.vue?vue&type=template&id=88b51b4c"
import script from "./Monolith.vue?vue&type=script&lang=js"
export * from "./Monolith.vue?vue&type=script&lang=js"
import style0 from "./Monolith.vue?vue&type=style&index=0&id=88b51b4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports